<template>
  <div class="prosedur">
    <div class="sd-heading p-b-16 p-t-16">
      <div class="d-flex align-items-center justify-content-between">
        <div class="d-flex flex-column align-items-start">
          <p
            class="f-Overpass f-w-400 m-0 f-12 mx-3 text-center align-items-start"
          >
            No Nota
          </p>
          <p
            class="f-Overpass f-w-600 m-0 f-14 mx-3 text-center align-items-start"
          >
            {{ dataCustomer.id }}
          </p>
        </div>

        <div class="d-flex flex-column align-items-end">
          <p
            class="f-Overpass f-w-400 m-0 f-12 mx-3 text-center align-items-start"
          >
            Tanggal
          </p>
          <p
            class="f-Overpass f-w-600 m-0 f-14 mx-3 text-center align-items-start"
          >
            {{ this.$moment(new Date()).format("L") }}
          </p>
        </div>
      </div>
    </div>

    <div class="p-a-16">
      <p class="f-Overpass m-0 f-16 f-w-600 f-c-black">
        {{ dataPesanan.namaMesin }}
      </p>
      <div class="d-flex flex-column p-t-8" style="gap: 8px">
        <p class="f-Overpass m-0 f-12 f-w-400 f-c-grey">Layanan</p>
        <p class="f-Overpass m-0 f-14 f-w-400 f-c-black">
          {{ dataPesanan.namaLayanan }}
        </p>
      </div>

      <div class="d-flex p-t-8" style="gap: 4px">
        <img src="../../../assets/icons/time.svg" alt="time" />
        <p class="f-Overpass f-12 f-w-400 mt-1 my-0 f-c-grey">
          {{ displayDuration }}
        </p>
      </div>

      <div class="d-flex p-t-4" style="gap: 4px">
        <img src="../../../assets/icons/location.svg" alt="time" />
        <p class="f-Overpass f-12 f-w-400 mt-1 my-0 f-c-grey">
          {{ dataCustomer.namaoutlet }}
        </p>
      </div>
    </div>

    <div
      class="payments d-flex flex-column align-items-start p-a-16"
      style="border-top: solid 2px #ededed; gap: 8px"
    >
      <div
        class="sd-detail d-flex justify-content-between align-items-start align-self-stretch"
      >
        <div class="start-text">
          <div
            class="d-flex flex-column justify-content-center align-items-start"
          >
            <p class="f-Overpass m-0 f-14 f-w-400 f-c-black">Saldo E-Pay</p>
            <p class="f-Overpass m-0 f-12 f-w-400 f-c-grey">
              E-Pay
              <span class="f-Overpass m-0 f-12 f-w-600 f-c-grey">{{
                dataCustomer.namacustomer
              }}</span>
            </p>
          </div>
        </div>
        <p
          class="d-flex flex-column align-items-end f-Overpass f-14 f-w-400 f-c-black"
        >
          {{ displaySaldo(this.dataCustomer.saldocustomer) }}
        </p>
      </div>

      <div
        class="d-flex justify-content-between align-items-center align-self-stretch"
      >
        <p class="f-Overpass m-0 f-14 f-w-400 f-c-black">Harga Layanan</p>
        <p class="f-Overpass m-0 f-14 f-w-400 f-c-red">
          -{{ displaySaldo(this.dataPesanan.total) }}
        </p>
      </div>

      <div class="w-100" style="border: dashed 1.1px #ededed" />
      <div
        class="d-flex justify-content-between align-items-center align-self-stretch"
      >
        <p class="f-Overpass m-0 f-14 f-w-400 f-c-black">Sisa Saldo</p>
        <p class="f-Overpass m-0 f-14 f-w-400 f-c-black">
          {{ displaySaldo(dataCustomer.saldocustomer - dataPesanan.total) }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "cardPayment",

  computed: {
    ...mapState("scan", {
      dataPesanan: "dataPesanan",
      dataCustomer: "dataCustomer",
    }),

    displayDuration() {
      const minutes = Math.floor(this.dataPesanan.durasiLayanan / 60);
      return `${minutes} Menit`;
    },
  },

  methods: {
    displaySaldo(money) {
      const formattedMoney = new Intl.NumberFormat("id-ID", {
        style: "currency",
        currency: "IDR",
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      }).format(money);

      return formattedMoney.replace(/\.00$/, "");
    },
  },
};
</script>

<style scoped>
.prosedur {
  border-radius: 16px;
  background: var(--primary-white, #fff);
  box-shadow: 0px 4px 12px 0px rgba(0, 34, 119, 0.06);
}

.sd-heading {
  color: #fff;
  border-radius: 16px 16px 0px 0px;
  background: var(--primary-product-smartlink, #206cfe);
}

.sd-body {
  gap: 8px;
  border-radius: 0px 0px 16px 16px;
}

.content-list li {
  margin-bottom: 10px;
}
</style>
